"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtendedCollections = void 0;
const compareBy_1 = require("./compareBy");
const unionBy_1 = require("./unionBy");
function getExtendedCollections(current, added) {
    if (!(added === null || added === void 0 ? void 0 : added.length)) {
        return current;
    }
    const newResources = unionBy_1.unionBy(current, added, 'id');
    return newResources.sort(compareBy_1.compareBy('name'));
}
exports.getExtendedCollections = getExtendedCollections;
//# sourceMappingURL=getExtendedCollections.js.map